import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "text-red-500 mt-4 -mb-16"
}
const _hoisted_5 = { class: "mt-20" }

import { // components
		DialogDescription
	} from '@headlessui/vue'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore as _localesStore
	} from '@/store/locales'

	import {
		Notification
	} from '@/types'

	import { // stores
		store as _userStore
	} from '@/store/user'
	
	import { // vue
		ref,
		onMounted
	} from 'vue'

	import {
		modifyUnavailability
	} from '../mutations'

	
	const __default__ = { name: "ChangeEmailForm" } 	// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		contact: {
			type: Object,
			default: () => {return {}}
		},
		data: {
			type: Object,
			default: () => {return {}}
		}
	},
  emits: ['closeUnavailabilityModal'],
  setup(__props, { emit: __emit }) {

	const {t} = useI18n()

	const props = __props

	const options = [
		{
			label: t('account.allDay'),
			value: "All Day"
		},
		{
			label: t('account.partialDay'),
			value: "Partial Day"
		}
	]

	const date = ref('')
	const inputDate = ref<null | {valid: Boolean}>(null)

	const unavailability = ref('')

	const timeStart = ref('')
	const inputTimeStart = ref<null | {valid: Boolean}>(null)

	const timeEnd = ref('')
	const inputTimeEnd = ref<null | {valid: Boolean}>(null)

	const loading = ref(false)
	const error = ref(false)
	const errorMsg = ref('')


	const localesStore = _localesStore()
	const userStore = _userStore()

	const emit = __emit

	onMounted(() => {
		// Values from the row selected
		if(Object.keys(props.data).length > 0) {
			const [month, day, year] = props.data['contacts__DAYSOFF__contactID::date'].split('/')
			date.value = `${year}-${month}-${day}`
			unavailability.value = props.data['contacts__DAYSOFF__contactID::availability_display']
			timeStart.value = props?.data['contacts__DAYSOFF__contactID::time_start']
			timeEnd.value = props?.data['contacts__DAYSOFF__contactID::time_end']
		}
	})
	
	async function submitUnavailability() {
		if (!date.value) {
			error.value = true
			errorMsg.value = "Date is required"
		}


		const [year, month, day] = date.value.split('-')
		const data = JSON.stringify({
			action: Object.keys(props.data).length === 0 ? "create" : "update",
			contactID: userStore.user.contactId,
			unavailabilityID: props.data['contacts__DAYSOFF__contactID::_kp_daysoff_id'],
			date: `${month}/${day}/${year}`,
			unavailability: unavailability.value,
			timeStart: timeStart.value,
			timeEnd: timeEnd.value
		})

		try{
			loading.value = true

			const result = await modifyUnavailability(data)

			const scriptResult = JSON.parse(result.response.scriptResult)

			const fmpError = scriptResult.errorCode !== 0

			if (fmpError) {
				throw new Error(scriptResult.errorMessage)
			}

			const notification: Notification = {
				title: t('placeholders.success'),
				subtitle: t("placeholders.unavailabilitySubmit"),
				icon: 0
			}

			emit('closeUnavailabilityModal', notification)

			date.value = ""
			unavailability.value = ""
			timeStart.value = ""
			timeEnd.value = ""
			error.value = false
			errorMsg.value = ""

		}
		catch (e) {
			error.value = true
			errorMsg.value = e.message
		}
		finally {
			loading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DialogDescription), {
      as: "h3",
      class: "mb-6"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('account.unavailabilityDescription')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('account.unavailabilityExample')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitUnavailability, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_tw_input, {
          modelValue: date.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
          id: "date",
          ref_key: "inputDate",
          ref: inputDate,
          required: true,
          type: "date",
          label: _unref(localesStore).getLabel('361'),
          class: "text-md"
        }, null, 8, ["modelValue", "label"]),
        _createVNode(_component_v_field, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_label, { "class-name": "block text-sm font-medium text-gray-700" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(localesStore).getLabel('678')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_select, {
              "class-name": "border rounded-md border-gray-300 focus:ring-brand-500 focus:border-brand-500 !text-gray-900",
              modelValue: unavailability.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unavailability).value = $event)),
              name: "unavailability"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
                  return _createElementVNode("option", {
                    value: option.value,
                    key: option.value
                  }, _toDisplayString(option.label), 9, _hoisted_3)
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_tw_input, {
          modelValue: timeStart.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((timeStart).value = $event)),
          id: "timeStart",
          ref_key: "inputTimeStart",
          ref: inputTimeStart,
          required: true,
          type: "time",
          label: _unref(localesStore).getLabel('144')
        }, null, 8, ["modelValue", "label"]),
        _createVNode(_component_tw_input, {
          modelValue: timeEnd.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((timeEnd).value = $event)),
          id: "timeEnd",
          ref_key: "inputTimeEnd",
          ref: inputTimeEnd,
          required: true,
          type: "time",
          label: _unref(localesStore).getLabel('322')
        }, null, 8, ["modelValue", "label"])
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMsg.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_tw_button, {
          disabled: loading.value,
          loading: loading.value,
          type: "submit",
          class: "btn-base btn-brand w-full"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('account.submitUnavailability')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ], 32)
  ], 64))
}
}

})